import CourseMain from "../components/Course/CourseMain"

const Course = () => {
  return (
    <>
    <CourseMain/>
    </>
  )
}

export default Course